import { isThemeToken } from '@nettbureau/theme';

/**
 * Parses the given transition easing into a CSS timing function value.
 *
 * @param theme - The theme object.
 * @param easing - The transition easing to resolve a value for.
 */ function parseTransitionEasing(theme, easing) {
    return isThemeToken(easing, theme.motionTimings) ? `cubic-bezier(${theme.motionTimings[easing].join(',')})` : easing;
}

export { parseTransitionEasing };
//# sourceMappingURL=transition-easing.js.map
